(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('SystemConfigService', SystemConfigService);

    SystemConfigService.$inject = ['$http', '$q', 'RequestService', 'ModalConstructor', 'AlertModalService', 'LoginService'];

    function SystemConfigService($http, $q, RequestService, ModalConstructor, AlertModalService, LoginService) {

        return {
            // Api Methods
            getSystemConfig: getSystemConfig,
            getBackupList: getBackupList,
            updateSystemConfig: updateSystemConfig,
            doBackup: doBackup,
            backupFromFavorite: backupFromFavorite,
            restoreBackup: restoreBackup,
            // Modal Methods
            listBackupModalConstructor: listBackupModalConstructor,
            errorModalConstructor: errorModalConstructor,
            successModalConstructor: successModalConstructor,
            confirmationModalConstructor: confirmationModalConstructor,
            restoreAppConfigInitial: restoreAppConfigInitial
        };

        // Api Methods
        function getSystemConfig() {
            return $http.get(configUrl()).then(responseData);
        }

        // Api Methods
        function getBackupList(data) {
            return $http.get(backupUrl(), {params: {path: data}}).then(responseData);
        }

        function updateSystemConfig(data) {
            return $http.put(configUrl(), data).then(responseData);
        }

        function doBackup(data) {
            return $http.post(backupUrl(), {path: data}).then(responseData);
        }

        function restoreAppConfigInitial(data) {
            return $http.post(backupUrl('restoreApp'), {path: data}).then(responseRestoreApp); 
        }

        function backupFromFavorite() {
            var dataAction = {
                action: 'backup',
                getPath: true,
                methodService: 'doBackup'
            };
            confirmationModalConstructor(dataAction);
        }

        function restoreBackup(data) {
            return $http.post(backupUrl('restore'), {file: data.filename, path: data.path}).then(responseData);
        }

        function listBackupModalConstructor(scope, backupPath) {
            var backupList = {
                templateUrl: 'app/components/backup-db/backup-list.html',
                controller: 'BackupListController',
                controllerAs: 'vmBackupList',
                backdrop: 'static',
                scope: scope,
                resolve: {
                    backupFolderPath: function () {
                        return backupPath
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('config');
                            return $translate.refresh();
                        }]
                }
            };
            return ModalConstructor.open(backupList);
        }

        function errorModalConstructor(response, action) {
            return AlertModalService.error(response, action, 'systemConfig');
        }

        function successModalConstructor(action, isMultiple) {
            return AlertModalService.success(action, isMultiple, 'systemConfig');
        }

        function confirmationModalConstructor(dataAction, confirmData) {
            var confirm = {
                templateUrl: 'app/components/backup-db/backup-confirm.html',
                controller: 'BackupConfirmController',
                controllerAs: 'vmBackupConfirm',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    dataAction: function () {
                        return dataAction
                    },
                    confirmData: function () {
                        return confirmData
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('config');
                            return $translate.refresh();
                        }]
                },
                avoidCancel: true
            };
            ModalConstructor.open(confirm);
        }

        // Helper functions
        function configUrl(method) {
            return RequestService.apiUrl('systemconfig', method);
        }

        function backupUrl(method) {
            return RequestService.apiUrl('systembackups', method);
        }

        // Return only the data of the response
        function responseData(response) {
            return response.data;
        }

        function responseRestoreApp(response) {
            LoginService.logout();
            return response.data;
        }

    }
})();